if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class extends AnimatedList {
    constructor() {
      const animatedListOptions = {
        panelSelector: '.disclosure__list-wrapper',
        toggleButtonSelector: 'button.localization-form__select',
        closeButtonSelector: '.country-selector__close-button',
        backdropSelector: '.modal__backdrop',
        searchInputSelector: 'input[name="country_filter"]',
        resetButtonSelector: '.country-filter__reset-button',
        focusableItemsSelector: 'a',
        scrollTrackSelector: 'custom-scrollbar',
        bodyOverflowClass: 'overflow-hidden-mobile',
        containerOpenClass: 'country-selector-open',
        containerSelector: '.menu-drawer',
        staggerSelector: 'ul li:not(.hidden)',
        duration: 0.25,
        staggerLimit: 8,
        initialOpacity: 0.1,
        staggerDuration: 0.2,
        stageDelay: 0.05
      };

      super(animatedListOptions);

      this.localizationElements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        searchIcon: this.querySelector('.country-filter__search-icon'),
        liveRegion: this.querySelector('#sr-country-search-results'),
        form: this.querySelector('form')
      };
      this.boundFilterCountries = this.filterCountries.bind(this);
      this.boundSearchKeyDown = this.onSearchKeyDown.bind(this);
      this.boundOnItemClick = this.onItemClick.bind(this);
      this.boundResetFilter = this.resetFilter.bind(this);

      this.initLocalizationEvents();

      if (this.closest('.menu-drawer') !== null) this.mobileList = true;
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        if (!DeviceUtils.isMobile && this.mobileList && this.isOpen) {
          this.forceClose();
        }
      }, 150);
    }

    initLocalizationEvents() {
      if (this.elements.searchInput) {
        this.elements.searchInput.removeEventListener('input', this.boundFilterCountries);
        this.elements.searchInput.removeEventListener('keydown', this.boundSearchKeyDown);
        this.elements.searchInput.addEventListener('input', this.boundFilterCountries);
        this.elements.searchInput.addEventListener('keydown', this.boundSearchKeyDown);
      }

      this.querySelectorAll('a').forEach(item => {
        item.removeEventListener('click', this.boundOnItemClick);
        item.addEventListener('click', this.boundOnItemClick);
      });

      if (this.elements.resetButton) {
        this.elements.resetButton.removeEventListener('click', this.boundResetFilter);
        this.elements.resetButton.addEventListener('click', this.boundResetFilter);
      }
    }

    onItemClick(event) {
      event.preventDefault();

      this.localizationElements.input.value = event.currentTarget.dataset.value;

      this.close();

      if (this.localizationElements.form) {
        this.localizationElements.form.submit();
      }
    }

    filterCountries() {
      const searchValue = this.normalizeString(this.elements.searchInput.value);
      const popularCountries = this.querySelector('.popular-countries');
      const allCountries = this.querySelectorAll('a');
      let visibleCountries = 0;

      this.elements.resetButton?.classList.toggle('hidden', !searchValue);

      if (popularCountries) {
        popularCountries.classList.toggle('hidden', !!searchValue);
      }

      allCountries.forEach((item) => {
        const countryElement = item.querySelector('.country');
        if (!countryElement) return;

        const countryName = this.normalizeString(countryElement.textContent);
        const isVisible = countryName.includes(searchValue);

        item.parentElement?.classList.toggle('hidden', !isVisible);

        if (isVisible) {
          visibleCountries++;
        }
      });

      if (this.localizationElements.liveRegion && window.accessibilityStrings?.countrySelectorSearchCount) {
        this.localizationElements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
          '[count]',
          visibleCountries
        );
      }

      this.scrollToTop();
      this.elements.scrollTrack?.updateThumbPosition();

      this.updateFocusTrap();
    }

    resetFilter(event) {
      event.stopPropagation();

      if (this.elements.searchInput) {
        this.elements.searchInput.value = '';
        this.filterCountries();
        this.elements.searchInput.focus();
      }
    }

    onSearchKeyDown(event) {
      if (event.code.toUpperCase() === 'ENTER') {
        event.preventDefault();
        return;
      }
    }

    normalizeString(str) {
      return str
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase();
    }

    scrollToTop() {
      const selector = this.querySelector('.country-selector');
      const list = this.querySelector('.country-selector__list');

      if (selector) selector.scrollTop = 0;
      if (list) list.scrollTop = 0;

      super.scrollToTop();
    }

    open() {
      super.open();

      this.elements.scrollTrack?.init();
    }

    setSelectedCountry(countryCode) {
      if (this.localizationElements.input) {
        this.localizationElements.input.value = countryCode;
      }
    }

    getSelectedCountry() {
      return this.localizationElements.input?.value || '';
    }

    refreshCountryList() {
      this.querySelectorAll('a').forEach(item => {
        item.removeEventListener('click', this.boundOnItemClick);
        item.addEventListener('click', this.boundOnItemClick);
      });

      this.updateFocusTrap();

      if (this.elements.searchInput?.value) {
        this.filterCountries();
      }
    }

    disconnectedCallback() {
      this.elements.searchInput?.removeEventListener('input', this.boundFilterCountries);
      this.elements.searchInput?.removeEventListener('keydown', this.boundSearchKeyDown);
      this.elements.resetButton?.removeEventListener('click', this.boundResetFilter);
      this.querySelectorAll('a').forEach((item) => {
        item.removeEventListener('click', this.boundOnItemClick);
      });
      super.disconnectedCallback();
    }
  });
}
